import { render, staticRenderFns } from "./DashboardCDPCQ.vue?vue&type=template&id=4024125a&scoped=true"
import script from "./DashboardCDPCQ.vue?vue&type=script&lang=js"
export * from "./DashboardCDPCQ.vue?vue&type=script&lang=js"
import style0 from "./DashboardCDPCQ.vue?vue&type=style&index=0&id=4024125a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024125a",
  null
  
)

export default component.exports